import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { WelcomeStatusEnum } from '../../../models/common/Enums';
import { GetWelcomeListPagingAndFilterRequest } from '../../../models/request/welcome/GetWelcomeListPagingAndFilterRequest';
import { GetWelcomeListPagingAndFilterResponseItem } from '../../../models/response/welcome/GetWelcomeListPagingAndFilterResponse';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import ColumnChooser from '../../ColumnChooser';
import Documents from '../../Documents';
import ExcelExportMenu from '../../ExcelExportMenu';
import { ExcelExportMode } from '../../../helpers/excelExportRequest';
import TableActions from '../../TableActions';
import TableConstantActions from '../../TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    changeWelcomeStatus: (_welcomeStatusId: string) => Promise<void>
    selectedCount: number
    filter: GetWelcomeListPagingAndFilterRequest
    getData: (_filter?: GetWelcomeListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: (value: React.SetStateAction<GetWelcomeListPagingAndFilterRequest>) => void
    isIn: boolean
    isOut: boolean
    items: GetWelcomeListPagingAndFilterResponseItem[]
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const CommonWelcomeListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    changeWelcomeStatus,
    selectedCount,
    filter,
    getData,
    setFilter,
    isIn,
    isOut,
    items,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Güncelle/Sil düğmeleri üst şeritte (liste ekranı standardı); arama kutusu kaldırıldı,
                Ref No ve Konteyner No kolon filtresinde. */}
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canDocument && (
                    <Documents
                        items={items.map(function (x) {
                            return { entityId: x.welcomeId, isSelected: x.isSelected }
                        })}
                        pageName={pageName}
                    />
                )
            }

            <TableActions
                list={[
                    { isDisabled: selectedCount == 0, text: 'Kantara Yönlendir', onClick: () => changeWelcomeStatus(WelcomeStatusEnum.ARAC_KANTARA_GIRDI) },
                    { isDisabled: selectedCount == 0, text: 'Sahaya Alındı', onClick: () => changeWelcomeStatus(WelcomeStatusEnum.ARAC_SAHAYA_ALINDI) },
                    { isDisabled: selectedCount == 0, text: 'Araç Sahaya Alınsın', onClick: () => changeWelcomeStatus(WelcomeStatusEnum.ARAC_SAHAYA_ALINSIN) },
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Müşteri, Tedarikçi, Araç Plaka, Dorse
                Plaka, Sürücü ve İşlem Durumu kolon başlığının altındaki filtrede var. İşlem
                Durumu varsayılanı (Sipariş Gelecek, Araç Geldi, Araç Sahaya Alınsın, Araç
                Sahaya Alındı, Araç Kantara Girdi) açılışta kolon filtresine konuyor. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate(isIn ? '/welcomein/listadd' : isOut ? '/welcomeout/listadd' : '')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Karşılama Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default CommonWelcomeListFilters;